import { FormConfig } from 'common.types'
import { PA_COUNTIES } from '../form.constants'
import validateLookupStatusEvent from '../status-lookup/helpers/lookup-status.event-validator'
import { StatusLookupHeaderContent } from '../status-lookup/components'

export const statusLookupConfig: FormConfig = {
  captchaStep: 1,
  requireEitherEmailOrPhone: true,
  fields: [
    {
      name: 'firstName',
      type: 'text',
      required: true,
      step: 1,
    },
    {
      name: 'middleName',
      type: 'text',
      step: 1,
    },
    {
      name: 'lastName',
      type: 'text',
      required: true,
      step: 1,
    },
    {
      name: 'suffix',
      type: 'select',
      step: 1,
      selectOptions: ['I', 'II', 'III', 'IV', 'JR', 'SR'],
    },
    {
      name: 'birthDate',
      type: 'date',
      required: true,
      validate: 'date',
      step: 1,
      maxDefaultDate: new Date('11/03/2008'),
    },
    {
      name: 'county',
      type: 'select',
      selectOptions: PA_COUNTIES,
      selectLabelsFromOptions: true,
      required: true,
      step: 1,
    },
    {
      name: 'zip',
      type: 'text',
      required: true,
      validate: 'zip',
      step: 1,
    },
    {
      name: 'email',
      type: 'text',
      validate: 'email',
      step: 1,
    },
    {
      name: 'phone',
      type: 'phone',
      step: 1,
      validate: 'phone',
    },
    {
      name: 'optInSms',
      type: 'checkbox',
      step: 1,
    },
    {
      name: 'dataConsent',
      type: 'checkbox',
      required: true,
      step: 1,
    },
  ],
  headerContent: StatusLookupHeaderContent,
  validateEventResponse: validateLookupStatusEvent,
}
